import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/VideoSection.css';
import Carousel from '../components/Carousel';
function Contact() {




  return (
    <section className="video-section2">
      <div className="container">
    <div className="section-separator" ></div>
      {/* Support Section */}
      <div style={{
        background: 'var(--primary-black)',
        padding: '50px 40px',
        borderRadius: '20px',
        textAlign: 'center',
        border: '2px solid var(--primary-orange)'
      }}>
        <h3 style={{
          fontSize: '2.3rem',
          marginBottom: '25px',
          color: 'var(--white)'
        }}>
          هل سبق لك أن تعرضتِ للعنف الرقمي؟
        </h3>
        <p style={{
          fontSize: '1.3rem',
          lineHeight: '1.8',
          marginBottom: '30px',
          color: 'var(--text-light)'
        }}>
          لستِ وحدك.
          <br />
        يمكنكن التواصل مع المجلس الوطني لحقوق الإنسان ولجانه الجهوية
        </p>

        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '20px',
          marginTop: '30px'
        }}>

        </div>

        <div style={{
          marginTop: '40px',
          padding: '25px',
          background: 'rgba(255, 107, 53, 0.1)',
          borderRadius: '15px',
          textAlign: 'center'
        }}>
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '12px' }}>    <img src="/images/logos/1.png" className="tab-icon4-img" /></div>
            <p style={{ fontSize: '1.2rem', color: 'var(--text-light)', lineHeight: '1.8' }}>
              <strong style={{ color: 'var(--primary-orange)', fontSize: '1.3rem' }}>المجلس الوطني لحقوق الإنسان ولجانه ال12</strong>
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '15px',
            marginTop: '15px'
          }}>
            <div>
              <p style={{ fontSize: '1.05rem', color: 'var(--text-light)' }}>
                <strong style={{ color: 'var(--primary-orange)' }}>البريد الإلكتروني</strong>
                <br />
                chikaya@cndh.org.ma
              </p>
            </div>
          </div>
        </div>
      </div>




            {/* Additional Platforms Section */}
            <div style={{ marginTop: '60px' }}>
              <h3 style={{
                fontSize: '2.3rem',
                marginBottom: '35px',
                textAlign: 'center',
                color: 'var(--white)'
              }}>
            جهات يمكن التواصل معها
              </h3>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '25px',

              }}>
                {[
                  {
                    icon: '/images/logos/1.png',
                    title: 'المجلس الوطني لحقوق الإنسان',
                    contacts: [
                      { type: 'البريد الإلكتروني', value: 'chikaya@cndh.org.ma' },
                      { type: 'الموقع', value: 'www.cndh.ma' },
                      { type: 'الهاتف', value: '0537540000' }
                    ]
                  },
                  {
                    icon: '/images/logos/2.png',
                    title: 'وزارة التضامن والإدماج الاجتماعي والأسرة',
                    contacts: [
                      { type: 'الموقع', value: 'gissr-amane.social.gov.ma' }
                    ]
                  },
                  {
                    icon: '/images/logos/3.png',
                    title: 'النيابة العامة',
                    contacts: [
                      { type: 'الموقع', value: 'plaintes.pmp.ma' }
                    ]
                  },
                  {
                    icon: '/images/logos/4.png',
                    title: 'المنصة الوطنية للتوعية الرقمية',
                    contacts: [
                      { type: 'الموقع', value: 'e-himaya.gov.ma' }
                    ]
                  },
                  {
                    icon: '/images/logos/5.png',
                    title: 'الدرك الملكيي',
                    contacts: [
                      {  value: 'مراكز الدرك الملكي' }
                    ]
                  },
                  {
                    icon: '/images/logos/6.png',
                    title: 'المديرية العامة للأمن الوطني',
                    contacts: [
                      { type: 'الموقع', value: 'e-blagh.ma' }
                    ]
                  },
                  {
                    icon: '/images/logos/7.png',
                    title: 'المنصة الخاصة',
                    contacts: [
                      { type: 'الموقع', value: 'www.cyberconfiance.ma' },
                      { type: 'الموقع', value: 'evigilance.ma' },
                      { type: 'الهاتف', value: '06 24 40 58 89' }
                    ]
                  },
                  {
                    icon: '/images/logos/8.png',
                    title: 'جمعيات المجتمع المدني المختصة',
                    contacts: [
                      { type: '', value: 'للحصول على الدعم والمساعدة من الجمعيات المتخصصة في مجال حماية النساء والفتيات' }
                    ]
                  },
                  {
                    icon: '/images/logos/8.png',
                    title: 'خلايا التكفل بالنساء ضحايا العنف',
                    contacts: [
                      { type: '', value: 'المحاكم الابتدائية والاستئنافية' },
                      { type: '', value: 'المستشفيات العمومية' },
                      { type: '', value: 'مصالح الشرطة والدرك الملكي' }
                    ]
                  }
                ].map((platform, index) => (
                  <div key={index} style={{
                    background: 'var(--primary-black)',
                    padding: '30px',
                    borderRadius: '15px',
                    border: '1px solid rgba(255, 107, 53, 0.3)',
                    transition: 'all 0.3s ease',

                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.borderColor = 'var(--primary-orange)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = 'rgba(255, 107, 53, 0.3)';
                  }}>
                    <div style={{ fontSize: '3rem', marginBottom: '15px', textAlign: 'center' }}>
                    <img src={platform.icon} className="tab-icon4-img" />
                    </div>
                    <h4 style={{
                      fontSize: '1.3rem',
                      marginBottom: '20px',
                      color: 'var(--primary-orange)',
                      textAlign: 'right',
                      lineHeight: '1.5'
                    }}>
                      {platform.title}
                    </h4>
                    <div style={{ fontSize: '1rem', lineHeight: '2', color: 'var(--text-light)' }}>
                      {platform.contacts.map((contact, idx) => (
                        <div key={idx} style={{ marginBottom: '10px' }}>
                          {contact.type ? (
                            <>
                              <strong>{contact.type}:</strong> {contact.value}
                            </>
                          ) : (
                            <>• {contact.value}</>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

            </div>
    <div className="section-separator" style={{ margin: '60px 0' }}></div>
            {/* Resources Section */}
            <Link to="/chiffres">
            <div style={{ marginTop: '60px' }} >
              <h3 style={{
                fontSize: '2.3rem',
                marginBottom: '35px',
                textAlign: 'center',
                color: 'var(--white)'
              }}>
            وثائق مرجعية
              </h3>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                gap: '25px'
              }}>
                {[
                  {
                    icon: '⚖️',
                    title: 'تملكي حقوقك وحرياتك',
                    desc: 'كما يكفلها الدستور المغربي والقانون الدولي لحقوق الإنسان',

                  }
                ].map((resource, index) => (
                  <div key={index} style={{
                    background: 'var(--primary-black)',
                    padding: '30px',
                    borderRadius: '15px',
                    border: '1px solid rgba(255, 107, 53, 0.3)',
                    textAlign: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.borderColor = 'var(--primary-orange)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = 'rgba(255, 107, 53, 0.3)';
                  }}>
                    <div style={{ fontSize: '3rem', marginBottom: '15px' }}>{resource.icon}</div>
                    <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: 'var(--primary-orange)' }}>
                      {resource.title}
                    </h4>
                    <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: 'var(--text-light)' }}>
                      {resource.desc}
                    </p>
                    {resource.subtitle && (
                      <p style={{
                        fontSize: '0.95rem',
                        lineHeight: '1.6',
                        color: 'var(--text-light)',
                        marginTop: '10px',
                        fontStyle: 'italic'
                      }}>
                        {resource.subtitle}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </div>
</Link>
      </div>
    </section>
  );
}

export default Contact;
